module.exports = __webpack_public_path__ + "img/delete-lines-red.89fc1b67.svg";